module.exports = __webpack_public_path__ + "dff4d1ec5720e4d71f78e669cfdb20fd.svg";